import { snackbarInfo } from '../SharedFunctions';

export const handleAdminInfo = (message: string) => {
    snackbarInfo(message);
};
